const documentsFilters = [
  {
    type: "text",
    id: "customer_name__text",
    label: "Cliente",
    value: null,
    category: "a",
    operators: [""],
    countries: ["PE", "CL"],
    title: 'Información del cliente',
    placeholder: 'Escribe el nombre de la razón social'
  },
  {
    type: "text",
    id: "customer_tax_id",
    label: "RUT",
    value: null,
    category: "a",
    operators: [],
    countries: ["PE", "CL"],
    title: 'Información del cliente',
    placeholder: 'Escribe el RUT'
  },
  {
    type: "date",
    id: "date",
    label: "Fecha del documento",
    value: null,
    value2: null,
    category: "b",
    operator: '',
    title: 'Fechas',
    operators: ['es igual', 'es menor a', 'es mayor a', 'rango'],
    countries: ["PE", "CL"],
    placeholder: ''
  },
  {
    type: "date",
    id: "created",
    label: "Fecha de creación",
    value: null,
    value2: null,
    category: "b",
    operator: '',
    title: 'Fechas',
    operators: ['es igual', 'es menor a', 'es mayor a', 'rango'],
    countries: ["PE", "CL"],
    placeholder: ''
  },
  {
    type: "select",
    isMultiple: true,
    id: "type",
    value: null,
    label: "Tipo de documento",
    choices: [],
    category: "c",
    title: 'Información del documento',
    countries: ["PE", "CL"],
    placeholder: 'Selecciona el tipo de documento'
  },
  {
    type: "text",
    id: "series",
    label: "Serie",
    value: null,
    category: "c",
    countries: ["PE"],
    title: 'Información del documento',
    placeholder: 'Escribe la serie'
  },
  {
    type: "numeric",
    id: "serial",
    label: "Correlativo",
    value: null,
    value2: null,
    category: "c",
    operator: '',
    title: 'Información del documento',
    operators: ['es igual', 'es menor a', 'es mayor a', 'rango'],
    countries: ["PE", "CL"],
    appendIcon: 'mdi-pound'
  },
  {
    type: "numeric",
    id: "amount_total",
    label: "Total",
    value: null,
    value2: null,
    category: "c",
    operator: '',
    operators: ['es igual', 'es menor a', 'es mayor a', 'rango'],
    countries: ["PE", "CL"],
    title: 'Información del documento',
    appendIcon: 'mdi-currency-usd'
  },
  {
    type: "boolean",
    id: "exists",
    label: "Documentos cedidos",
    value: null,
    booleanValue: "assignment_agency_status",
    category: "c",
    countries: ["CL"],
    title: 'Información del documento'
  },
  {
    type: 'text',
    id: 'order_reference',
    label: 'Orden de compra',
    value: null,
    category: 'c',
    operators: [''],
    countries: ['PE', 'CL'],
    title: 'Información del documento',
    placeholder: 'Escribe la orden de compra'
  },
  {
    type: "text",
    id: "batch_id",
    label: "Lote",
    value: null,
    category: "c",
    operators: [],
    countries: ["PE", "CL"],
    title: 'Información del documento',
    placeholder: 'Escribe el ID del lote'
  },
  {
    type: "text",
    id: "agency_status_info__text",
    label: "Detalle del estado",
    value: null,
    category: "e",
    operators: [""],
    countries: ["PE", "CL"],
    title: 'Estado',
    placeholder: 'Escribe el detalle del estado'
  },
  {
    type: "text",
    id: "branch_id",
    label: "Tienda y caja",
    value: null,
    value2: null,
    category: "f",
    operator_branch: 'es igual',
    operator_cpos: 'es igual',
    operators_branch: ["es igual", "no tiene"],
    operators_cpos: ["es igual", "es distinto a"],
    isCombined: true,
    dependent: {
      type: "text",
      id: "cpos_id",
      label: "POS"
    },
    title: 'Tienda y POS',
    countries: ["PE", "CL"]
  },
  {
    type: "text",
    id: "destination_branch_id",
    label: "Código de tienda",
    value: null,
    category: "g",
    operators: [],
    countries: ["PE"],
    title: 'Tienda de destino',
    placeholder: 'Escribe el código de la tienda de destino'
  },
  {
    type: "text",
    id: "destination_branch_name__text",
    label: "Nombre de tienda",
    value: null,
    category: "g",
    operators: [''],
    countries: ["PE"],
    title: 'Tienda de destino',
    placeholder: 'Escribe el nombre de la tienda de destino'
  }
]
export { documentsFilters }
